
<script setup>
import { useLocalization } from '@/locales/localization';
import {onMounted} from "vue";
const { detectAndSetLocale } = useLocalization();

onMounted(() => {
  detectAndSetLocale();
});

</script>

<template>


  <router-view />

</template>

<style scoped>

</style>